import { topics } from '@/mocks/topics';

export default function Topics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              热门话题
            </h2>
            <p className="text-sm text-foreground-500 mt-1">当前最火的娱乐圈话题</p>
          </div>
          <span className="text-xs text-foreground-400 bg-background-200/70 px-3 py-1.5 rounded-full">
            实时热度
          </span>
        </div>

        <div className="flex flex-wrap gap-3">
          {topics.map((topic, idx) => {
            const sizeClass =
              idx < 2
                ? 'text-base md:text-lg px-5 py-3'
                : idx < 5
                  ? 'text-sm md:text-base px-4 py-2.5'
                  : 'text-xs md:text-sm px-3 py-2';

            return (
              <a
                key={topic.id}
                href="#cards"
                className={`${sizeClass} bg-background-50 border border-background-200/70 rounded-full hover:border-primary-300 hover:bg-primary-50/50 transition-all flex items-center gap-2 group cursor-pointer whitespace-nowrap`}
              >
                <span className="text-xs font-bold text-primary-500">#{idx + 1}</span>
                <span className="font-medium text-foreground-800">{topic.name}</span>
                <span className="text-[10px] text-accent-600 bg-accent-100/80 px-1.5 py-0.5 rounded-full flex items-center gap-0.5">
                  <i className={`${topic.icon} text-[10px]`}></i>
                  {topic.heat}
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}